// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	LIST: '[data-fragment="Faq.list"]',
	ITEM: '[data-fragment="Faq.item"]',
	HEADER: '[data-fragment="Faq.header"]',
	BODY: '[data-fragment="Faq.body"]',
};

class Faq extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
		this.state = {};
	}

	didMount() {
		const {
			activeClass,
		} = this.props;

		this.activeClass = activeClass;

		this.on('click', fragments.HEADER, this.handleClickOnHeader);

	}

	handleClickOnHeader = (e) => {
		let itemElement = e.target.parentElement.parentElement;
		let bodyElement = e.target.parentElement.nextElementSibling;
		if (!itemElement.classList.contains(this.activeClass)) {
			itemElement.classList.add(this.activeClass);
			setTimeout(() => {
				bodyElement.style.maxHeight = bodyElement.clientHeight + 'px';
			},100);
		} else {
			itemElement.classList.remove(this.activeClass);
			bodyElement.style.maxHeight = null;
		}
	}
}

Faq.defaultProps = {
	activeClass: 'faq__item--active',
};

export default Faq;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Faq.js